import styled, {ThemeProps} from 'styled-components';

import {Theme} from './../../../../theme/types';
import {Column, Row, ColumnStyles} from './../../common/Layouts/Layouts';

import Image from '@stencil/image';

export const WrapperDiv = styled(Row)(
  (props: ThemeProps<Theme>) => `
  padding: ${props.theme.spacing.xlarge};
  border-radius: ${props.theme.misc.borderRadius.large};
  border: 0.1rem solid ${props.theme.colors.goBrandBlue.light};
  margin-bottom: 15px;
  margin-top: 10px;
`,
);

export const UserAvatarWrapperDiv = styled(Row)(
  (props: ThemeProps<Theme>) => `
  padding-right: ${props.theme.spacing.small};
  width: 5%;
`,
);

export const UserReviewOuterWrapperDiv = styled(Column)(
  (props: ThemeProps<Theme>) => `
  padding-left: ${props.theme.spacing.small};
  width: 95%;
`,
);

export const UserReviewWrapperDiv = styled(Column)(
  (props: ThemeProps<Theme>) => `
  padding-top: ${props.theme.spacing.xlarge};
  padding-bottom: ${props.theme.spacing.xlarge};
`,
);

export const UserReviewTextStyle = styled.span(
  (props: ThemeProps<Theme>) => `
line-height: 1.4;
font-size: ${props.theme.font.custom(16)};
text-decoration: none!important;

&.active {
  font-weight: 600;
}
`,
);

export const MoreReviewTextStyle = styled.span(
  (props: ThemeProps<Theme>) => `
line-height: 1.4;
font-size: ${props.theme.font.custom(16)};
color: ${props.theme.colors.goBrandBlue.dark};
cursor: pointer;
`,
);

export const UserDetailsAndRatingWrapperDiv = styled(Row)(
  (props: ThemeProps<Theme>) => `
  justify-content: space-between;
  align-items: center;
`,
);

export const UserReviewImageListWrapperDiv = styled(Row)(
  (props: ThemeProps<Theme>) => `
  padding-top: ${props.theme.spacing.xlarge};
  padding-bottom: ${props.theme.spacing.xlarge};
`,
);

export const RowWithPadT10 = styled(Row)(
  (props: ThemeProps<Theme>) => `
  padding-top: ${props.theme.spacing.base};
`,
);

export const RowWithMarginR10 = styled(Row)(
  (props: ThemeProps<Theme>) => `
  margin-right: ${props.theme.spacing.base};
`,
);

export const LikeSectionWrapperDiv = styled(Row)(
  (props: ThemeProps<Theme>) => `
  padding-bottom: ${props.theme.spacing.base};
  align-items: baseline;
`,
);

export const StyledImage = styled(Image)(
  props => `
  display: flex;
  height: 100%;
  width: 100%;
  object-fit: cover;
  height: ${props.height}rem;
  width: ${props.width}rem;
  border-radius: ${props.theme.misc.borderRadius.large};
`,
);

// export const RatingWrapperDiv = styled(Column)(
//   props => {
//     let backgroundColor, color;
//     if (props.totalRating >= 1.0 && props.totalRating <= 1.9) {
//       backgroundColor = props.theme.colors.goRed.light;
//       color = props.theme.colors.goRed.base;
//     } else if (props.totalRating >= 2.0 && props.totalRating <= 2.9) {
//       backgroundColor = props.theme.colors.goBrandOrange.light;
//       color = props.theme.colors.goBrandOrange.light;
//     } else if (props.totalRating >= 3.0 && props.totalRating <= 3.9) {
//       backgroundColor = props.theme.colors.goGreen.light;
//       color = props.theme.colors.goGreen.medium;
//     } else if (props.totalRating >= 4.0 && props.totalRating <= 5) {
//       backgroundColor = props.theme.colors.goGreen.dark;
//       color = props.theme.colors.goGreen.base;
//     } else {
//       backgroundColor = props.theme.colors.goGreen.dark;
//       color = props.theme.colors.goRed.light;
//     }
//     return
//      `padding: ${props.theme.spacing.small};
//       border-radius: ${props.theme.misc.borderRadius.base};
//       background-color: ${props.theme.colors.goGreen.base};
//     `,
//   }
// );

export const HotelierResponseWrapperDiv = styled(Column)(
  (props: ThemeProps<Theme>) => `
  width: 90%;
  padding-top: ${props.theme.spacing.base};
`,
);

export const HotelierResponseContentWrapperDiv = styled(Column)(
  (props: ThemeProps<Theme>) => `
  width: 90%;
  padding-top: ${props.theme.spacing.base};
`,
);

export const HotelierResponseContentStyle = styled.div(
  (props: ThemeProps<Theme>) => `
${ColumnStyles}
padding: ${props.theme.spacing.large} ${props.theme.spacing.base} ${props.theme.spacing.large} ${props.theme.spacing.base};
width: 100%;
border-radius: ${props.theme.misc.borderRadius.large};
background-color: ${props.theme.colors.goBrandBlue.light};
`,
);

export const HotelierNameTextStyle = styled.p(
  (props: ThemeProps<Theme>) => `
font-size: ${props.theme.font.custom(14)};
color: ${props.theme.colors.downriver.medium};
`,
);

export const HotelierResponseTextStyle = styled.p(
  (props: ThemeProps<Theme>) => `
font-size: ${props.theme.font.custom(16)};
color: ${props.theme.colors.downriver.dark};
padding-top: ${props.theme.spacing.small};
`,
);

export const HelpfulTextStyle = styled.span(
  (props: ThemeProps<Theme>) => `

color: ${props.theme.colors.goBrandBlue.base};
`,
);

export const LikeTextWrapper = styled.span(
  (props: ThemeProps<Theme>) => `

color: ${props.theme.colors.goBrandBlue.base};
padding-left: ${props.theme.spacing.base};
cursor: pointer;
&.active{
  font-weight:bold;
}
`,
);

export const LikeTextStyle = styled.span(
  (props: ThemeProps<Theme>) => `

color: ${props.theme.colors.goBrandBlue.base};
padding-left: ${props.theme.spacing.custom(4)};
cursor: pointer;
&.active{
  font-weight:bold;
}
`,
);

export const RatingTextStyle = styled.span(
  (props: ThemeProps<Theme>) => `
font-weight: bold;
font-size: ${props.theme.font.custom(16)};
color: white;
`,
);

export const UserNameStyle = styled.span(
  (props: ThemeProps<Theme>) => `
font-weight: bold;
font-size: ${props.theme.font.custom(16)};
text-transform: capitalize;
`,
);

export const StayedOnStyle = styled.span(
  (props: ThemeProps<Theme>) => `
color: ${props.theme.colors.downriver.dark};
font-size: ${props.theme.font.custom(14)};
padding-left: ${props.theme.spacing.small};
`,
);

export const AskedByStyle = styled.p(
  (props: ThemeProps<Theme>) => `
color: ${props.theme.colors.downriver.dark};
font-size: ${props.theme.font.custom(14)};
padding-top: ${props.theme.spacing.custom(7)};
`,
);
